import { apiIdle, apiRequest } from "@data/redux/actions/api"
import React, { useEffect, useState } from "react"
import { Searchbar } from "react-native-paper"
import { connect } from "react-redux"

const ServerSearch = (props) => {
    const {
        style,
        urlParams,
        setUrlParams,
        value = null,
        placeholder = "Rechercher...",
        updateUrl = false,
        navigation = null,
    } = props

    const [previousSearchQuery, setPreviousSearchQuery] = useState("")
    const [searchQuery, setSearchQuery] = useState(urlParams?.search ?? "")

    // Sync searchQuery with urlParams when it changes externally
    useEffect(() => {
        if (
            urlParams?.search !== undefined &&
            urlParams?.search !== searchQuery
        ) {
            setSearchQuery(urlParams.search)
            setPreviousSearchQuery(urlParams.search)
        }
    }, [urlParams?.search])

    useEffect(() => {
        if (searchQuery === previousSearchQuery) return

        const delayDebounceFn = setTimeout(() => {
            const updatedParams = {
                ...urlParams,
                search: searchQuery,
            }

            // Update URL params if navigation is provided
            if (updateUrl && navigation) {
                navigation.setParams({
                    search: searchQuery || undefined,
                })
            }

            if (JSON.stringify(urlParams) !== JSON.stringify(updatedParams)) {
                setUrlParams(updatedParams)
            }

            setPreviousSearchQuery(searchQuery)
        }, 500)

        return () => clearTimeout(delayDebounceFn)
    }, [searchQuery, updateUrl, navigation])

    const onChangeSearch = (query) => setSearchQuery(query)

    return (
        <Searchbar
            placeholder={placeholder}
            onChangeText={(value) => {
                onChangeSearch(value)
            }}
            value={value ?? searchQuery}
            style={{
                ...style,
            }}
            inputStyle={{
                fontSize: 14,
            }}
        />
    )
}

const mapStateToProps = (state) => {
    return {
        users: state.data.users?.usersList,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(ServerSearch)
